import React from "react";
import ReactToPrint from "react-to-print";
import { ToWords } from "to-words";

// this code link

// https://codesandbox.io/embed/react-to-print-96kg7

class ComponentToPrint extends React.Component {
  // location = useLocation();
  toWords = new ToWords();
  orderDets = {};
  // payment = "COD";
  // company = "Furniba";
  // customer = "Swapnil";
  // // phoneNumber = 9428333101;
  // address = (
  //   <p style={{ fontSize: 14, paddingTop: 5, margin: 0 }}>
  //     <div>
  //       <span>ADDRESS:</span>
  //       <br />
  //       customername:"{this.customer}"
  //       <br />
  //       flatnumber:"heritage elegant apartments"
  //       <br />
  //     </div>
  //     {/* <br/> */}
  //   </p>
  // );
  // addresss end
  //
  render() {
    console.log(JSON.parse(localStorage.getItem("orderDetails")));
    this.orderDets = JSON.parse(localStorage.getItem("orderDetails"));
    return (
      <div
        style={{
          maxWidth: "890px",
          margin: "auto",
          padding: "10px",
          border: "1px solid #eee",
          boxShadow: "0 0 10px rgba(0, 0, 0, .15)",
          fontSize: "14px",
          lineHeight: "24px",
          fontFamily:
            "'Helvetica Neue', 'Helvetica', Helvetica, Arial, sans-serif",
          color: "#555",
        }}
      >
        <table
          cellPadding="0"
          cellSpacing="0"
          style={{ width: "100%", borderCollapse: "collapse" }}
        >
          <tbody>
            <tr className="top_rw" style={{ backgroundColor: "#f4f4f4" }}>
              <td colSpan={2}>
                <h2 style={{ marginBottom: "0px" }}>
                  {" "}
                  Tax invoice/Bill of Supply/Cash memo{" "}
                </h2>
                <span>
                  {" "}
                  Date: {new Date(this.orderDets.createdAt).toDateString()}{" "}
                </span>
              </td>
              <td style={{ width: "30%", marginRight: "10px" }}>
                Order Id: {this?.orderDets?.order_id}
              </td>
            </tr>{" "}
            <br />
            <tr
              className="top"
              style={{
                paddingBottom: "20px",
                fontSize: "23px",
                lineHeight: "30px",
                color: "#333",
                width: "100%",
              }}
            >
              <td colSpan={3}>
                <table>
                  <tbody>
                    <tr>
                      <td style={{
                        fontSize: "1rem",
                        lineHeight: "1rem"
                      }}>
                        <b> Sold By: {this.company} </b> <br />
                        G28, BIP, BORANADA, JODHPUR<br/> 7230005524, - 23 <br/>GSTIN/UIN:
                        08ADEFS6670B1Z2 <br/>State Name : Rajasthan, Code : 08<br/> E-Mail
                        : steelglow.jodhpur@gmail.com
                        {/* Delhivery Pvt. Ltd. Plot No. A5 Indian Corporation
                        Warehouse Park Village Dive-anjur, Bhiwandi, Off Nh-3,
                        Near Mankoli Naka, District Thane, Pin Code: 421302
                        Mumbai, Maharashtra - 421302 PAN: AALFN0535C GSTIN:
                        27AALFN0535C1ZK */}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
            <br />
            <tr
              className="information"
              style={{
                paddingBottom: "20px",
                width: "142%",
                display: "block",
                textAlign: "center",
              }}
            >
              <td colSpan={3}>
                <table
                  style={{
                    // paddingBottom: "20px",
                    width: "100%",
                    // display: "block",
                    // textAlign: "center",
                  }}
                >
                  <tbody>
                    <tr>
                      <td
                        colSpan={2}
                        style={{
                          textAlign: "left",
                          width: "50%",
                        }}
                      >
                        <b>
                          {" "}
                          Shipping Address:{" "}
                          {this?.orderDets?.address?.address_name}{" "}
                        </b>
                        <br />
                        {this.orderDets?.address?.society},{" "}
                        {this.orderDets?.address?.city},{" "}
                        {this.orderDets?.address?.state},{" "}
                        {this.orderDets?.address?.postal_code},{" "}
                        {this.orderDets?.address?.mobile_no}{" "}
                        {this.orderDets?.address?.email}
                        <br />
                        <br />
                      </td>
                      <td
                        style={{
                          textAlign: "right",
                          width: "50%",
                        }}
                      >
                        {" "}
                        <b>
                          {" "}
                          Shipping Address:{" "}
                          {this?.orderDets?.address?.address_name}{" "}
                        </b>
                        <br />
                        {this.orderDets?.address?.society},{" "}
                        {this.orderDets?.address?.city},{" "}
                        {this.orderDets?.address?.state},{" "}
                        {this.orderDets?.address?.postal_code},{" "}
                        {this.orderDets?.address?.mobile_no}{" "}
                        {this.orderDets?.address?.email}
                        <br />
                        <br />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>{" "}
            <br />
            <br />
            <tr colSpan={3}>
              <table
                style={{ width: "142%" }}
                cellSpacing="0px"
                cellPadding="2px"
              >
                <tbody>
                  <tr
                    className="heading"
                    style={{
                      background: "#eee",
                      borderBottom: "1px solid #ddd",
                      fontWeight: "bold",
                      fontSize: "12px",
                    }}
                  >
                    <td style={{ width: "25%" }}>ITEM</td>
                    <td style={{ width: "10%", textAlign: "center" }}>QTY.</td>
                    <td style={{ width: "10%", textAlign: "center" }}>
                      PRICE (INR)
                    </td>
                    {/* <td style={{ width: "15%", textAlign: "right" }}>
                      TAX RATE & TYPE
                    </td>
                    <td style={{ width: "15%", textAlign: "right" }}>
                      TAX AMOUNT (INR)
                    </td> */}
                    <td style={{ width: "15%", textAlign: "right" }}>
                      TOTAL AMOUNT (INR)
                    </td>
                  </tr>
                  {this?.orderDets?.cart?.cartitems?.map((item, i) => {
                    return (
                      <>
                        <tr className="item">
                          <td style={{ width: "25%" }}>
                            {item?.product?.product_name}
                          </td>
                          <td style={{ width: "10%", textAlign: "center" }}>
                            {item?.product_quantity}
                          </td>
                          <td style={{ width: "10%", textAlign: "right" }}>
                            {item?.product?.product_offer_price
                              ? item?.product?.product_offer_price
                              : item?.product?.product_price}
                          </td>
                          {/* <td style={{ width: "15%", textAlign: "right" }}>
                            18% IGST
                          </td>
                          <td style={{ width: "15%", textAlign: "right" }}>57.97</td> */}
                          <td style={{ width: "15%", textAlign: "right" }}>
                            {item?.product?.product_offer_price
                              ? item?.product?.product_offer_price *
                                item?.product_quantity
                              : item?.product?.product_price *
                                item?.product_quantity}
                          </td>
                        </tr>
                      </>
                    );
                  })}
                  {/* <tr className="item">
                    <td style={{ width: "25%" }}>
                      Johnson's Baby Skincare Wipes 80s Pack Of 2 Rs. 60 Off HSN
                      Code :4818 novajj079
                    </td>
                    <td style={{ width: "10%", textAlign: "center" }}>2</td>
                    <td style={{ width: "10%", textAlign: "right" }}>322.03</td>
                    <td style={{ width: "15%", textAlign: "right" }}>
                      18% IGST
                    </td>
                    <td style={{ width: "15%", textAlign: "right" }}>57.97</td>
                    <td style={{ width: "15%", textAlign: "right" }}>380</td>
                  </tr> */}
                  <tr className="item">
                    <td style={{ width: "25%" }}>
                      {" "}
                      <b> Grand Total </b>{" "}
                    </td>
                    <td style={{ width: "10%", textAlign: "center" }}></td>
                    <td style={{ width: "10%", textAlign: "right" }}></td>
                    {/* <td style={{ width: "15%", textAlign: "right" }}></td>
                    <td style={{ width: "15%", textAlign: "right" }}>57.97</td> */}
                    <td style={{ width: "15%", textAlign: "right" }}>
                      {this.orderDets?.order_subtotal}
                    </td>
                  </tr>
                </tbody>
              </table>
            </tr>
            <tr
              className="total"
              style={{
                borderTop: "2px solid #eee",
                fontWeight: "bold",
              }}
            >
              <td colSpan="3" align="right">
                {" "}
                Total Amount in Words :{" "}
                <b>
                  {" "}
                  {this.toWords.convert(this.orderDets?.order_subtotal)}{" "}
                </b>{" "}
              </td>
            </tr>{" "}
            <br />
            <br />
            <tr>
              <td colSpan="3">
                <table cellSpacing="0px" cellPadding="2px">
                  <tr>
                    <td width="50%">
                      <b> Declaration: </b> <br />
                      We declare that this invoice shows the actual price of the
                      goods described above and that all particulars are true
                      and correct. The goods sold are intended for end user
                      consumption and not for resale.
                    </td>
                    <td
                      style={{
                        textAlign: "right",
                      }}
                    >
                      * This is a computer generated invoice and does not
                      require a physical signature
                    </td>
                  </tr>
                  <tr
                    style={{
                      textAlign: "right",
                    }}
                  >
                    <td width="50%"></td>
                    <td>
                      <b> Authorized Signature </b>
                      <br />
                      <br />
                      ...................................
                      <br />
                      <br />
                      <br />
                    </td>
                  </tr>
                </table>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  }
}

class Example extends React.Component {
  render() {
    return (
      <div>
        <ReactToPrint
          trigger={() => <a href="#">Print this out!</a>}
          content={() => this.componentRef}
        />
        <ComponentToPrint ref={(el) => (this.componentRef = el)} />

        {/* for double print uncomment below line */}
        {/* <ComponentToPrint ref={(el) => (this.componentRef = el)} /> */}
      </div>
    );
  }
}

export default Example;
